import { Component, OnInit } from '@angular/core';
import { NotasService } from '../../service/notas.service';
import { JsonLdService } from '../../service/json-ld.service';
import { Router, NavigationEnd } from '@angular/router';
import { Meta, Title } from '@angular/platform-browser';
import { UrlcanonicaService } from '../../service/urlcanonica.service';
import { filter } from 'rxjs/operators';
import { DomSanitizer } from '@angular/platform-browser';
import { DatePipe } from '@angular/common';

@Component({
  selector: 'app-nota',
  templateUrl: './nota.component.html',
  styleUrls: ['./nota.component.css']
})

export class NotaComponent implements OnInit {
  nota!: any;
  notas!: any[];
  idnotshow: any;
  newstr: any;
  tituloseo: any;
  descripcionseo: any;
  urlcanonicaseo: any;
  imagenseo: any;
  date: Date | undefined;
  datepipe: any;
  url: any;
  RouteText: any;
  contenido: any;

  

  constructor(
    private _jsonLdService: JsonLdService,
    private _urlcanonicaservice: UrlcanonicaService,
    private _notasService: NotasService,
    private sanitizer: DomSanitizer,
    private router: Router,
    private meta: Meta,
    private datePipe:DatePipe,
    private title: Title
  ){ 

    
    this.router.events.pipe(filter((event: any) => event instanceof NavigationEnd)).subscribe((event: NavigationEnd) => {
      this.RouteText = event;
      const splitString = this.RouteText.url.substring().split("/")
      this.url = splitString[2];
      this.getNoticia();
    this.getNoticiaHistorico();
    });
  }

  getNoticia(){
    console.log('Llamando al servicio con URL:', this.url);
    this._notasService.getByUrl(this.url).subscribe((resp: any) =>{
      //console.log('Respuesta del servicio:', resp);
      this.nota = resp;
      this.contenido = this.getSanitizing(this.nota?.contenido);
      //console.log('Contenido sanitizado:', this.contenido);
      let latest_date = this.datePipe.transform( new Date(resp.fechaactualizacion),'yyyy-MM-dd  h:mm:ss');
      this._urlcanonicaservice.createCanonicalLink();
      
      var schema = [
        {
            "id": `https://fundacionbest.org.mx/nota/${this.nota.url}`,
            "headline": `${this.nota.titulo}`,
            "description": `${this.nota.descripcion}`,
            "image": `https://fundacionbest.org.mx/${this.nota.urlimagen}`,
            "datePublished": latest_date,
            "dateModified": latest_date
        }
      ]
      this._jsonLdService.insertSchema(schema);
      this.title.setTitle( `${this.nota.titulo}`);
      this.meta.updateTag({ name: 'robots', content: 'index, follow' });
      this.meta.updateTag({ name: 'description',content: ` ${this.nota.descripcion}`});
      this.meta.updateTag({ property: 'og:url',content: `${this._urlcanonicaservice.createCanonicalLink()}`});
      this.meta.updateTag({ property: 'og:title',content: `${this.nota.titulo}`});
      this.meta.updateTag({ property: 'og:image',content: `https://fundacionbest.org.mx/${this.nota.urlimagen}`});
      this.meta.updateTag({ property: 'og:description',content: ` ${this.nota.descripcion}`});
      this.meta.updateTag({ property: 'twitter:card',content: 'summary'});
      this.meta.updateTag({ property: 'twitter:site',content: '@fundacionbest'});
      this.meta.updateTag({ property: 'twitter:title',content: `${this.nota.titulo}`} );
      this.meta.updateTag({ property: 'twitter:description',content: `${this.nota.descripcion}`});
      this.meta.updateTag({ property: 'twitter:image',content: `https://fundacionbest.org.mx/${this.nota.urlimagen}`} );
  
  
  
      if(!this.nota){
        this.router.navigate(['notas']);
      }
    })
  }

  getSanitizing(stringSanitizing: any) {
    
    return this.sanitizer.bypassSecurityTrustHtml(stringSanitizing);
  }

  getNoticiaHistorico() {
    // this._notasService.getNotasHome().subscribe((resp: any) => {
    //   var first = Math.floor(Math.random()*resp.length);
    //   var second = first+2;
    //   this.notas = resp.slice(first, second);
    // });
    this._notasService.getNotasHome().subscribe((resp: any) => {
      this.notas = resp;
    });
  }
 
  getNotaUrl(nota: any) {
    this.newstr = nota.urlNota.toLowerCase();
    //this.newstr = this.newstr.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
    this.router.navigate(["/nota/" + nota.id + "/" + this.newstr]);
    // por si se necesita remplazar caractes especiales
    // this.newstr = this.newstr.replace(/[^\w\s]/gi, '');
  }

  getAll(){
    this.router.navigate(['notas']);
  }

  ngOnInit(): void {
    
  }

}

